// extracted by mini-css-extract-plugin
export default {"verifiedOld":"verified-badge_verifiedOld__Xpr-k","verifiedBlue":"verified-badge_verifiedBlue__lh1Uv","verifiedGovernment":"verified-badge_verifiedGovernment__qFOtb"};